import mapDataSource, { RawDataSource } from '~/Api/DataSource/mapDataSource';
import mapProductPrice, { RawProductPrice } from '~/Api/Product/mapProductPrice';

import type {
	BrandAnalyticsComputedUnitPriceResponse,
	BrandAnalyticsComputedTreatmentCostResponse,
} from 'com.cogvio.pricemonitor.api';

import ActualPack from './ActualPack';
import ActualPackStatus, { Status } from './ActualPackStatus';

import UnitPrice from '~/Api/Product/UnitPrice';
import { PriceType } from '~/Domain';
import TreatmentCost from '~/Api/Product/TreatmentCost';

export interface RawActualPack {
	id: string;
	dataSource: RawDataSource;
	companyName: string | null;
	hasPrices: boolean;
	prices: RawProductPrice[];
	packageSizeForSingleUnit: number;
	status: { value: string; reasonFields: { [reason: string]: string } };
	unitPrice: BrandAnalyticsComputedUnitPriceResponse | null;
	treatmentCost: BrandAnalyticsComputedTreatmentCostResponse | null;
}

export default function mapActualPack(actualPack: RawActualPack): ActualPack {
	let unitPrice: UnitPrice | null = null;
	let treatmentCost: TreatmentCost | null = null;

	if (actualPack.unitPrice !== null) {
		const { type, value, currency, physicalUnit } = actualPack.unitPrice;
		unitPrice = new UnitPrice(type as PriceType, currency, value, physicalUnit);
	}

	if (actualPack.treatmentCost !== null) {
		const { type, value, currency, physicalUnit } = actualPack.treatmentCost;
		treatmentCost = new TreatmentCost(type as PriceType, currency, value, physicalUnit);
	}

	return new ActualPack(
		actualPack.id,
		mapDataSource(actualPack.dataSource),
		actualPack.companyName,
		actualPack.hasPrices,
		actualPack.prices.map(mapProductPrice),
		actualPack.packageSizeForSingleUnit,
		new ActualPackStatus(actualPack.status.value as Status, actualPack.status.reasonFields),
		unitPrice,
		treatmentCost
	);
}
